import { render, staticRenderFns } from "./MeetingRecaps.vue?vue&type=template&id=2ad4a014&lang=pug"
import script from "./MeetingRecaps.vue?vue&type=script&lang=js"
export * from "./MeetingRecaps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports